import React, { Component } from 'react';
import Scroll from './Scroll';
import Logo from '../assets/img/Logo.svg';
import { Link } from 'gatsby';

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openMenu: false,
    };
  }
  toggleMenu = value => {
    this.setState({ openMenu: value });
  };

  render() {
    const { openMenu } = this.state;
    return (
      <nav
        className={`navbar navbar-expand-lg navbar-light fixed-top py-3 navbar-scrolled`}
        id="mainNav"
      >
        <div className="container">
          <Link
            className="navbar-brand"
            to="/"
            onClick={_ => this.toggleMenu(false)}
          >
            <img
              src={Logo}
              alt="Wasescha Maler – Malerbetrieb in Savognin, Val Surses GR"
              style={{ height: 48 }}
            />
          </Link>

          <button
            onClick={_ => this.toggleMenu(!openMenu)}
            className={`navbar-toggler navbar-toggler-right ${
              openMenu ? '' : 'collapsed'
            }`}
            type="button"
            aria-controls="navbarResponsive"
            aria-expanded={openMenu}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className={`collapse navbar-collapse ${openMenu ? 'show' : ''}`}
            id="navbarResponsive"
          >
            <ul className="navbar-nav ml-auto my-2 my-lg-0 align-items-center">
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/#services"
                  onClick={_ => this.toggleMenu(false)}
                >
                  Angebot
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to={'/über-mich'}
                  onClick={_ => this.toggleMenu(false)}
                >
                  Über mich
                </Link>
              </li>
              <li className="nav-item ml-lg-3">
                <Link
                  className="btn btn-primary btn-sm px-3 py-2"
                  to="/#contact"
                  onClick={_ => this.toggleMenu(false)}
                  style={{ borderRadius: '10rem', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.75rem' }}
                >
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}